import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import {TicketQuota, TicketQuotaMessage} from "../models"
import {MessageActions} from "./message.actions"
import { UnsafeAction } from "./UnsafeAction"

@Injectable()
export class TicketQuotaActions {

	static SET_SELECTED_TICKETQUOTA = '[TicketQuota] Set selected Ticket Quota';
	setSelectedTicketQuota(ticketQuota:TicketQuota):UnsafeAction {
		return {
			type: TicketQuotaActions.SET_SELECTED_TICKETQUOTA,
			payload: ticketQuota
		};
	}

	static LOAD_COLLECTION = '[TicketQuota] Load TicketQuota Collection';
	loadCollection(collectionUrl:string): UnsafeAction {
		return {
			type: TicketQuotaActions.LOAD_COLLECTION,
			payload: collectionUrl
		};
	}

	static LOAD_COLLECTION_SUCCESS = '[TicketQuota] Load Collection Success';
	loadCollectionSuccess(ticketQuotaCollection: TicketQuota[]): UnsafeAction {
		return {
			type: TicketQuotaActions.LOAD_COLLECTION_SUCCESS,
			payload: ticketQuotaCollection
		};
	}

	static REFRESH_COLLECTION = '[TicketQuota] Refresh TicketQuota Collection';
	refreshCollection(collectionUrl: string): UnsafeAction {
		return {
			type: TicketQuotaActions.REFRESH_COLLECTION,
			payload: collectionUrl
		};
	}

	static REFRESH_COLLECTION_SUCCESS = '[TicketQuota] Refresh TicketQuota Collection Success';
	refreshCollectionSuccess(ticketQuotaCollection: TicketQuota[]): UnsafeAction {
		return {
			type: TicketQuotaActions.REFRESH_COLLECTION_SUCCESS,
			payload: ticketQuotaCollection
		};
	}

	static CREATE_TICKETQUOTA = '[TicketQuota] Create Ticket Quota';
	createTicketQuota(ticketQuota:TicketQuota):UnsafeAction {
		return {
			type: TicketQuotaActions.CREATE_TICKETQUOTA,
			payload: ticketQuota
		};
	}

	static CREATE_TICKETQUOTA_SUCCESS = '[TicketQuota] Create Ticket Quota Sucess';
	createTicketQuotaSuccess(newTicketQuota:TicketQuota):UnsafeAction {
		return {
			type: TicketQuotaActions.CREATE_TICKETQUOTA_SUCCESS,
			payload: newTicketQuota
		};
	}

	static LINK_TICKETQUOTAS = '[TicketQuota] Link Ticket Quotas';
	linkTicketQuotas():Action {
		return {
			type: TicketQuotaActions.LINK_TICKETQUOTAS
		};
	}

	static UPDATE_TICKETQUOTA = '[TicketQuota] Update Ticket Quota';
	updateTicketQuota(ticketQuota:TicketQuota):UnsafeAction {
		return {
			type: TicketQuotaActions.UPDATE_TICKETQUOTA,
			payload: ticketQuota
		};
	}

	static UPDATE_TICKET_QUOTA_SUCCESS = '[TicketQuota] Update Ticket Quota Success';
	updateTicketQuotaSuccess(updatedTicketQuota:TicketQuota):UnsafeAction {
		return {
			type: TicketQuotaActions.UPDATE_TICKET_QUOTA_SUCCESS,
			payload: updatedTicketQuota
		}
	}

	static DELETE_TICKET_QUOTA = '[TicketQuota] Delete Ticket Quota';
	deleteTicketQuota(ticketQuotaToBeDeleted):UnsafeAction {
		return {
			type: TicketQuotaActions.DELETE_TICKET_QUOTA,
			payload: ticketQuotaToBeDeleted
		}
	}

	static DELETE_TICKET_QUOTA_SUCCESS = '[TicketQuota] Delete Ticket Quota Success';
	deleteTicketQuotaSuccess(deletedTicketQuota):UnsafeAction {
		return {
			type: TicketQuotaActions.DELETE_TICKET_QUOTA_SUCCESS,
			payload: deletedTicketQuota
		}
	}

	static SET_TICKET_QUOTA_IN_EDIT = '[TicketQuota] Set Ticket Quota in edit';
	setTicketQuotaInEdit(ticketQuotaForEdit:TicketQuota) {
		return {
			type: TicketQuotaActions.SET_TICKET_QUOTA_IN_EDIT,
			payload: ticketQuotaForEdit
		}
	}

	static LOAD_TICKETQUOTA_MESSAGES = '[TicketQuota] load Ticket Quota Messages';
	loadTicketQuotaMessages(ticketQuotaMessageUrl:string):UnsafeAction {
		return {
			type: TicketQuotaActions.LOAD_TICKETQUOTA_MESSAGES,
			payload: ticketQuotaMessageUrl
		}
	}

	static LOAD_TICKETQUOTA_MESSAGES_SUCCESS = '[TicketQuota] load Ticket Quota Messages success';
	loadTicketQuotaMessagesSuccess(displayTicketQuotaMessages:TicketQuotaMessage[]):UnsafeAction {
		return {
			type: TicketQuotaActions.LOAD_TICKETQUOTA_MESSAGES_SUCCESS,
			payload: displayTicketQuotaMessages
		}
	}

	static POST_TICKETQUOTA_MESSAGE = '[TicketQuota] Post TicketQuota Message';
	postTicketQuotaMessage(ticketQuotaMessage:TicketQuotaMessage):UnsafeAction {
		return {
			type: TicketQuotaActions.POST_TICKETQUOTA_MESSAGE,
			payload: ticketQuotaMessage
		}
	}

	static RELOAD_TICKETQUOTA = '[TicketQuota] Reload TicketQuota';
	reloadTicketQuota(ticketQuotaId: string): UnsafeAction {
		return {
			type: TicketQuotaActions.RELOAD_TICKETQUOTA,
			payload: ticketQuotaId
		}
	}

	static RELOAD_TICKETQUOTA_SUCCESS = '[TicketQuota] Reload TicketQuota success';
	reloadTicketQuotaSuccess(ticketQuota: TicketQuota): UnsafeAction {
		return {
			type: TicketQuotaActions.RELOAD_TICKETQUOTA_SUCCESS,
			payload: ticketQuota
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/actions/ticket-quota.actions.ts